<template>
    <label class="form-switch form-switch-pill d-block" :class="switchClass" v-on:click="swap" :title="title">
        <input :name="getFieldName()" type="hidden" :value="value">
        <!-- controllo per attivare la checkbox" -->
        <input type="checkbox" v-model="toggleActive">
        <i v-if="dataSwitched" data-on="v" data-off="x"></i>
        <i v-else data-on="x" data-off="v"></i>
    </label>
</template>

<script>
import wBase from './wBase'
import {wSwapMixin} from 'crud-vue-core'

export default {
  name: 'w-swap',
  extends: wBase,
  mixins: [wSwapMixin],
}
</script>

<style scoped>

</style>
